/* =========================================
   FILTER TOGGLE
========================================= */

var filterButton = document.getElementById('OpenFilter');
var filterSidebar = document.getElementById('FilterSidebar');

if(filterButton && filterSidebar){

    filterButton.addEventListener('click', function(){

        filterSidebar.classList.toggle('active');

    });

}

/* =========================================
   ACCORDION
========================================= */

var accordionButtons = document.querySelectorAll('.cc-accordion-btn');

accordionButtons.forEach(function(button){

    button.addEventListener('click', function(){

        var accordion = this.parentElement;

        accordion.classList.toggle('active');

    });

});
/* =========================================
   GRID SWITCHER
========================================= */
const viewButtons = document.querySelectorAll('.cc-view-btn');
const productGrid = document.querySelector('.cc-grid');

function applyGrid(cols){

    if(window.innerWidth > 768){

        productGrid.style.gridTemplateColumns = `repeat(${cols},1fr)`;

    } else {

        productGrid.style.setProperty('--mobile-cols', cols);

    }

    localStorage.setItem('gridCols', cols);

    viewButtons.forEach(btn=>{

        btn.classList.toggle(
            'active',
            btn.dataset.grid === cols
        );

    });

}

viewButtons.forEach(button=>{

    button.addEventListener('click',()=>{

        applyGrid(button.dataset.grid);

    });

});

const savedGrid = localStorage.getItem('gridCols');

if(savedGrid){

    applyGrid(savedGrid);

}
/* =========================================
   RESET GRID ON RESIZE
========================================= */

window.addEventListener('resize', function(){

    if(window.innerWidth <= 768){

        if(productGrid){

            productGrid.style.gridTemplateColumns = 'repeat(2,minmax(0,1fr))';

        }

    }

});

document.addEventListener("click", function(e){

    const button=e.target.closest(".cc-wishlist-overlay");

    if(!button) return;

    const productId=button.dataset.productId;

    const requiresLogin=button.dataset.requiresLogin;

    if(requiresLogin){

        window.location.href="/account/login?return_url="+window.location.pathname;

        return;

    }

    let wishlist=JSON.parse(localStorage.getItem("wishlist")) || [];

    if(!wishlist.includes(productId)){

        wishlist.push(productId);

        localStorage.setItem("wishlist",JSON.stringify(wishlist));

    }

});